import React, { useState } from "react";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import ListElement from "./ListElements/ListElements";
import localeText from "../../locale";

const ModalNotifications = (props) => {
  const { notifications } = props;
  const [showModal, setShowModal] = useState(false);

  const lastFiveNotifications = notifications.slice(-5);
  const reversedNotifications = lastFiveNotifications.reverse();

  const totalNotRead = reversedNotifications.reduce(
    (accumulator, currentValue) => accumulator + (!currentValue.sent ? 1 : 0),
    0
  );

  return (
    <div
      style={{
        position: "relative",
        display: "inline",
        float: "right",
        margin: 5,
        zIndex: 5,
      }}
      // onBlur={() => setShowModal(false)}
    >
      <Button
        icon="pi pi-bell b-none"
        className="bg-primary border-primary"
        onClick={() => setShowModal((state) => !state)}
      />
      <div
        style={{
          position: "absolute",
          right: "-10px",
          top: "-5px",
          width: "18px",
          height: "18px",
          borderRadius: "18px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 5,
          backgroundColor: "#D32F2F",
          color: "white",
        }}
      >
        {totalNotRead}
      </div>
      {showModal && (
        <div
          style={{
            position: "absolute",
            right: "-15px",
            top: "50px",
            minWidth: "300px",
            maxWidth: "400px",
            minHeight: "50px",
            backgroundColor: "white",
            borderRadius: "5px",
            boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)",
          }}
        >
          {reversedNotifications.length > 0 ? (
            <div>
              <p
                className="font-bold m-0 text-left"
                style={{
                  padding: "15px",
                  borderBottom: "2px solid #272360",
                }}
              >
                {localeText("notifications")}
              </p>
              {reversedNotifications.map((notification, index) => (
                <ListElement key={index} notification={notification} />
              ))}
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: "50px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: "15px",
              }}
            >
              {localeText("noNotifications")}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ModalNotifications;
